import React from 'react';
import Icon from '../../../components/AppIcon';
import { isToday, formatDateWithDay, formatTimeWithoutSeconds, calculateEndTime } from '../../../utils/dateUtils';

const DailySummaryCard = ({ date, appointments = [], onBookingClick }) => {
  const isTodayDate = isToday(date);
  const dayName = date?.toLocaleDateString('en-US', { weekday: 'long' });
  const dateString = formatDateWithDay(date);

  const sortedAppointments = [...appointments]?.sort((a, b) => {
    return a?.time?.localeCompare(b?.time);
  });

  return (
    <div className={`p-4 md:p-5 lg:p-6 bg-card border rounded-lg transition-smooth ${
      isTodayDate ? 'border-primary shadow-elevation-2' : 'border-border shadow-elevation-1'
    }`}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className={`text-base md:text-lg lg:text-xl font-heading font-semibold ${
            isTodayDate ? 'text-primary' : 'text-foreground'
          }`}>
            {dayName}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mt-1">{dateString}</p>
        </div>
        {isTodayDate && (
          <div className="px-2 md:px-3 py-1 bg-primary/10 rounded-full">
            <span className="text-xs md:text-sm font-caption font-medium text-primary">Today</span>
          </div>
        )}
      </div>
      <div className="space-y-3">
        {sortedAppointments?.length > 0 ? (
          sortedAppointments?.map((apt) => {
            const startTime = formatTimeWithoutSeconds(apt?.time);
            const endTime = calculateEndTime(apt?.time, apt?.duration);
            
            return (
              <div
                key={apt?.id}
                onClick={() => onBookingClick?.(apt)}
                className="p-3 md:p-4 bg-background border border-border rounded-lg hover:border-primary/50 transition-smooth cursor-pointer"
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-base font-medium text-foreground truncate">
                      {apt?.customer_name}
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground mt-1 truncate">
                      {apt?.service}
                    </p>
                  </div>
                  <div className="flex items-center gap-1 text-accent">
                    <Icon name="Clock" size={14} />
                    <span className="text-xs md:text-sm font-data font-medium whitespace-nowrap">
                      {startTime} - {endTime}
                    </span>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="py-6 md:py-8 text-center">
            <Icon name="CalendarX" size={32} className="mx-auto mb-2 text-muted-foreground opacity-50" />
            <p className="text-xs md:text-sm text-muted-foreground">No appointments</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DailySummaryCard;